import { SUBSCRIPTION_FORM_KEYS } from "utils/constants";
import BankAccount from "./BankAccount";
import CommunityAttachment from "./CommunityAttachment";
import Id from "./Id";
import Kbis from "./Kbis";
import PensionFund from "./PensionFund";
import SocialSecurityCertificate from "./SocialSecurityCertificate";
import SupportingDocuments from "./SupportingDocuments";
import PaySlip from "./paySlip";
import TaxNotice from "./taxNotice";

const generateProofForm = ({
  isTNS,
  acceptTeletransmission,
  isRetired,
  isCommunityDocumentRequired,
  isFPH,
  isTaxed,
}) => ({
  [SUBSCRIPTION_FORM_KEYS.PROOF.SOCIAL_SECURITY_CERTIFICATE]:
    acceptTeletransmission && SocialSecurityCertificate,
  [SUBSCRIPTION_FORM_KEYS.PROOF.ID]: Id,
  [SUBSCRIPTION_FORM_KEYS.PROOF.BANK_ACCOUNT]: BankAccount,
  [SUBSCRIPTION_FORM_KEYS.PROOF.PAY_SLIP]: isFPH && PaySlip,
  [SUBSCRIPTION_FORM_KEYS.PROOF.TAX_NOTICE]: isTaxed && TaxNotice,
  [SUBSCRIPTION_FORM_KEYS.PROOF.KBIS]: isTNS && Kbis,
  [SUBSCRIPTION_FORM_KEYS.PROOF.PENSION_FUND]: isRetired && PensionFund,
  [SUBSCRIPTION_FORM_KEYS.PROOF.COMMUNITY_ATTACHMENT]:
    isCommunityDocumentRequired && CommunityAttachment,
  [SUBSCRIPTION_FORM_KEYS.PROOF.SUPPORTING_DOCUMENTS]: SupportingDocuments,
});

export default generateProofForm;
